// removed by extract-text-webpack-plugin
module.exports = {"rotate":"global__rotate___1bdIE","fadein":"global__fadein___2X4F7","slideFromRight":"global__slideFromRight___2wFHU","waves":"global__waves___3_Bvh"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/global.scss
// module id = ./resources/assets/js/styles/global.scss
// module chunks = 0